import { Injectable, SkipSelf } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { EnvService } from 'src/app/env.service';
import {
  UserDetailModel,
  DeleteUserModel,
  UpdateUserModel,
  GetUserModel,
  ExistUserCheckModel,
} from 'src/app/viewModels/users/UserListModel';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { ResetPasswordReqVM } from 'src/app/viewModels/resetPassword/reset-password-req-vm';
import { ApiEndPointsUser } from '../../common/apiUrls/api-end-points';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  private baseUrl:any;
  private baseUrlTran:any;
  _content: string;
  constructor(
    @SkipSelf() private _http: HttpClient,
    private apiAddress: ApiEndPointsUser,
    public env: EnvService,
    private constant: Constants
  ) {

    
    if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
    this.baseUrl = this.constant.ManageUserPortNumber;
else
    this.baseUrl = this.env.apiUrl+this.constant.ManageUserPortNumber;
    if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
    this.baseUrlTran = this.constant.ManageTranscationportNumber;
else
    this.baseUrlTran = this.env.apiUrl+this.constant.ManageTranscationportNumber;
  }

  //private baseUrl = this.env.apiUrl;
  //private baseUrl = this.env.apiUrl + this.constant.ManageUserPortNumber;
  //private baseUrl = this.constant.ManageUserPortNumber;

  // private options_: any = {
  //   headers: new HttpHeaders({
  //     'Content-Type': 'application/json-patch+json',
  //     'Accept': 'text/plain'
  //   })
  // };

  // To get User List
  getUserList(data: any): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.userList;
    return this._http.post(apiURL, data).pipe();
  }
  // To register new User
  registerUser(data: UserDetailModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.registerUser;
    return this._http.post(apiURL, data).pipe();
  }
  // To get User detail
  getUserDetail(data: GetUserModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.getUserDetail;
    return this._http.post(apiURL, data).pipe();
  }
  // To update User
  updateUser(data: UpdateUserModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.updateUser;
    return this._http.post(apiURL, data);
  }
  // To delete User
  deleteUser(data): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.deleteUser;
    return this._http.post(apiURL, data).pipe();
  }
  // To check existing User
  checkExistingUser(data: ExistUserCheckModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.checkExistingUser;
    return this._http.post(apiURL, data).pipe();
  }

  getUserDetailsManageUser(userID): Observable<any> {
    const apiURL =  this.baseUrl + this.apiAddress.getLoggedInUserDetailsManageUser;
    return this._http.post(apiURL, userID);
  }

  updateUserProfile(dataModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.updateUserProfile;
    return this._http.post(apiURL, dataModel);
  }

  getImageUlpoadURL(reqModel): Observable<any> {
    const apiURL = this.baseUrlTran + this.apiAddress.getImageUploadURL;
    return this._http.post(apiURL, reqModel).pipe();
  }

  setMFA(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.setMFA;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addUserService  (reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.addUserService;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getUserProfileServices  (reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.getUserProfileServices;
    return this._http.post(apiURL, reqModel).pipe();
  }
  AddUpdateUserNotificationPreferances  (reqModel): Observable<any> {
    const apiURL =  this.baseUrl + this.apiAddress.AddUpdateUserNotificationPreferances;
    return this._http.post(apiURL, reqModel).pipe();
  }
  getSuperAdminThirdPartyApi(reqModel): Observable<any> {      
    const apiURL = this.baseUrl+ this.apiAddress.getSuperAdminThirdPartyApi;  
    return this._http.post(apiURL,reqModel).pipe();
  }
}
